import styled from 'styled-components';
import { arrayOf, number, shape, string, func } from 'prop-types';

import CategoryFilter from './CategoryFilter';
import RangeFilter from '../shared/RangeFilter';
import { DESKTOP_SIZE, MOBILE_SIZE } from '../../constants';
import { withI18next } from '../../lib/withI18next';

const Container = styled.div`
  padding: 50px 80px;
  @media (max-width: ${DESKTOP_SIZE}) {
    padding: 0px 15px 10px;
  }
`;

const RangeFilterContainer = styled.div`
  margin: 40px 0 0 0;
  display: grid;
  grid-template-rows: 1fr 1fr;
  @media (min-width: ${DESKTOP_SIZE}) {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    grid-template-rows: 1fr;
  }
  @media (max-width: ${MOBILE_SIZE}) {
    margin-bottom: 3rem;
  }
`;

const GamesFilter = ({
  age,
  players,
  updateQuery,
  updateFilterState,
  categories,
  updateCategory,
  selectedCategories,
  t,
}) => (
  <Container>
    <CategoryFilter
      selectedCategories={selectedCategories}
      categories={categories}
      updateCategory={updateCategory}
    />
    <RangeFilterContainer>
      <RangeFilter
        name="players"
        maxValue={10}
        minValue={1}
        value={players}
        updateQuery={updateQuery}
        updateFilterState={updateFilterState}
        label={t('COMPONENTS_GAMES_FILTER_RANGE_PLAYERS_LABEL')}
      />
      <RangeFilter
        name="age"
        maxValue={21}
        minValue={3}
        value={age}
        updateQuery={updateQuery}
        updateFilterState={updateFilterState}
        label={t('COMPONENTS_GAMES_FILTER_RANGE_AGE_LABEL')}
      />
    </RangeFilterContainer>
  </Container>
);

GamesFilter.propTypes = {
  categories: arrayOf(
    shape({
      name: string.isRequired,
      id: string.isRequired,
    }).isRequired
  ),
  selectedCategories: arrayOf(string.isRequired),
  updateQuery: func.isRequired,
  updateCategory: func.isRequired,
  updateFilterState: func.isRequired,
  players: shape({
    min: number.isRequired,
    max: number.isRequired,
  }).isRequired,
  age: shape({
    min: number.isRequired,
    max: number.isRequired,
  }).isRequired,
};

export default withI18next()(GamesFilter);



// WEBPACK FOOTER //
// components/GamesFilter/index.js